var $9223d369de089ee2$exports = {};
$9223d369de089ee2$exports = {
    "loading": `A carregar...`,
    "loadingMore": `A carregar mais...`
};


export {$9223d369de089ee2$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
